// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4ydZd","label":"styles_label__2OoyN"};